module.exports = __webpack_public_path__ + "img/pointrule.bf2c8211.png";